import { Col, Row, Card, Button, Divider } from "antd";
import React from "react";
import styled from "styled-components";
import ProductImage from "../../assets/images/productCard.jpg";
import CustomModal from "../modals/customModal";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const ProductCardWrapper = styled(Card)`
  min-height: 300px;
  margin: 10px;
  background-image: url(${(props) => props.image});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  .meta {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    color: #fff;
    padding-bottom: 10px;
    text-align: center;
  }
  .orange.darken-2 {
    background-color: #f57c00 !important;
  }
  .button {
    font-size: 12px;
    text-transform: uppercase;
    padding: 5px 8px;
    border-radius: 50px;
  }
  .red.darken-2 {
    background-color: #d32f2f !important;
  }
  .green.darken-2 {
    background-color: #388e3c !important;
  }
  .primarygreen.darken-2 {
    background-color: #009688 !important;
  }
  .meta ul li {
    font-size: 18px;
    font-weight: 500;
    margin-top: 5px;
    list-style-type: none;
  }
`;

function ProductCard({
  data,
  productData,
  onConfigure,
  onDeactive,
  onAdd,
  fromNewCatalog,
  onhandleButton,
}) {
  console.log("DATA==>", data);
  return (
    <ProductCardWrapper image={data?.image?.original}>
      <Row className="meta" justify="center">
        <ul className="no-margin" style={{ padding: "0.5em 0px" }}>
          <Col span={24}>
            <li className="capitalize no-margin truncate">{data?.name}</li>
          </Col>
          <Col span={24}>
            {/* {cookies.get("contractor_credentials") && ( */}
              <>
                <li className="uppercase no-margin truncate">
                    {
                  data?.rmx_product_prices?.length > 0 ?  `${data?.rmx_product_prices[0]?.rmx_product_price?.currency} ${Number(data?.rmx_product_prices[0]?.rmx_product_price?.price)?.toFixed(2) || 0} /${data?.unit}` :
                  `$${Number(data?.price)?.toFixed(2) || 0} /${data?.unit}`
                  }
                </li>
                {/* <li
                  className="uppercase no-margin truncate"
                  style={{ marginBottom: "4px" }}
                >
                  {fromNewCatalog && `$${Number(data?.price)?.toFixed(2) || 0} / ${data?.unit}`}
                </li> */}
              </>
            {/* )} */}
          </Col>
          <Col span={24}>
            <Row justify="center" gutter={[13, 10]}>
              {!fromNewCatalog && (
                <Col span={24}>
                  <p
                    className={
                      " button orange darken-2 text-white pointer-cursor"
                    }
                    onClick={() => onConfigure()}
                    style={{ textAlign: "center", marginRight: "-8px" }}
                  >
                    Configure
                  </p>
                </Col>
              )}
              {fromNewCatalog && (
                <Col span={24}>
                  <span
                    className={
                      productData?.some((item) => item?.id === data?.id)
                        ? "button orange darken-2 text-white pointer-cursor text-center"
                        : "button primarygreen darken-2 text-white pointer-cursor text- center"
                    }
                    style={{
                      textAlign: "center",
                      justifyContent: "center ",
                    }}
                    onClick={() => onAdd()}
                  >
                    {productData?.some((item) => item?.id === data?.id)
                      ? "Edit"
                      : "Add"}
                  </span>
                </Col>
              )}

              {!fromNewCatalog && (
                <Col span={12}>
                  <p
                    className={
                      data.status === 1
                        ? "button red darken-2 text-white pointer-cursor"
                        : "button green darken-2 text-white pointer-cursor"
                    }
                    style={{
                      textAlign: "center",
                      marginRight: data.status === 2 ? "" : "-8px",
                    }}
                    onClick={onDeactive}
                  >
                    {data.status === 1 ? "deactivate" : "activate"}
                  </p>
                </Col>
              )}
            </Row>
          </Col>
        </ul>
      </Row>
    </ProductCardWrapper >
  );
}
export default ProductCard;
